import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '@rsuite/icons/Menu';
import GridIcon from '@rsuite/icons/Grid';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import { useNavigate } from 'react-router-dom';
import SortUpIcon from '@rsuite/icons/SortUp';
import globalIP from '../../../GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import { useInView } from 'react-intersection-observer';
import ImageIcon from '@rsuite/icons/Image';
import AddOutlineIcon from '@rsuite/icons/AddOutline';
import PushMessageIcon from '@rsuite/icons/PushMessage';
import useFilter from './Filters';
import FunnelIcon from '@rsuite/icons/Funnel';
import SortDrawer from './SortDrawer';
import useLabel from '@/clientWeb/hook/Label';
import {
  handleDownloadQR1,
  handleDownloadQR2,
  handleDownloadQR3,
  handleDownloadQR6,
  handleDownloadQR7,
  handleDownloadQR8
} from '../../../components/functions/printQRFunctions';
import { downloadExcelData } from '../../../components/functions/printExcelFunctions';
import {
  handleDownloadPDF1,
  handleDownloadPDF2,
  handleDownloadPDF3
} from '../../../components/functions/printPDFFunctions';
import {
  fetchColors,
  fetchFinishes,
  fetchHsn,
  fetchMaterials,
  fetchCategory,
  fetchSkuUnique,
  fetchAlias,
  fetchBuyers,
  fetchMadeBy,
  fetchHeads,
  fetchProductLabel,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchProductTypes
} from '../../../apiService/apiService';
import {
  Input,
  InputGroup,
  Table,
  Button,
  ButtonGroup,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  ButtonToolbar,
  Tooltip,
  IconButton,
  Whisper,
  Loader,
  SelectPicker,
  Message,
  useToaster,
  Dropdown,
  Checkbox,
  InputNumber,
  Footer,
  FlexboxGrid
} from 'rsuite';
import { Dropdown as AntdDropDown, Select, Button as AntdBtn, Modal } from 'antd';
import SearchIcon from '@rsuite/icons/Search';
import SmartSearchModal from './smart-search-modal';
import Library from './Library';
import ProductImage from './ProductImage';
import VariantDatatable from './VariantDatatable';
import NavD from './NavD';
import ugr from '@/UGRoute';
import axios from 'axios';
import ProductCard from '@/components/ProductSearchPage/ProductCard';
import ProductQuickView from '@/components/ProductSearchPage/ProductQuickView';
import ProdductListView from '@/components/ProductSearchPage/ProdductListView';
import ShowDimensionModal from '@/components/ShowDimensionModal';
import FilterDrawer from '@/components/FilterDrawer';
import HeaderFilter from '@/components/HeaderFilter';
import useUser from '../../../components/UseUser';
import { EditFilled, EyeFilled, FilterOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { setProductCount } from '@/store/dashboardSlice';

// import AddedOnFIlter from '@/components/AddedOnFilter';
interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string;
    ProductTypeCode: string;
    ProductCode: string;
    ProductId: string;
    ProductName: string;
    Description: string;
    SizeUnit: 'Inch';
    Length: 0;
    Width: 0;
    Height: 0;
    FinishCode: null;
    ColorCode: null;
    NetWeight: 0;
    GrossWeight: 0;
    HSNCode: string;
    SellingPriceCurrency: string;
    SellingPriceUnit: string;
    SellingPrice: 0;
    ProductCost: 0;
    SearchKeyword: string;
    MOQ: string;
    ProductDesigner: null;
    MadeBy: null;
    CategoryName: string;
    ProductTypeName: null;
    cbm: null;
    FinishName: null;
    ColorName: null;
    BuyerName: null;
    BuyerSku: null;
    SizeRange: null;
    Total_CBM: null;
    Total_CFT: null;
    TwentyFT: null;
    FortyFT: null;
    FortyHQ: null;
    Variant_Id: string;
    Variant: boolean;
    CoverImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    MultipleImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    ProductionDetail: [
      {
        id: string;
        ProductCode: string;
        MaterialNm: string;
        MaterialFinishNm: string;
        MatNetWeight: 0;
        MaterialCode: string;
        MaterialFinishCode: string;
      }
    ];
    // Add other attributes if needed
  };
}

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const { HeaderCell, Cell } = Table;
const authstatus = ['Authorised', 'Pending'].map(item => ({ label: item, value: item }));
const DataTable = () => {
  const dispatch = useDispatch();

  const ipp = globalIP;
  const { user } = useUser();
  // const [data, setData] = React.useState(defaultData);
  const [data123, setData123] = useState<RowData[]>([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedmaterial, setSelectedmaterial] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
  const [currentPage, setCurrentPage] = useState(1);
  const [progress, setProgress] = useState(0);
  const [isLoadingTableData, SetIsLoadingTableData] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [authst, setAuthst] = useState('Authorised');
  const [tableMeta, setTableMeta] = useState([]);
  const [reload, setReload] = useState(false);
  const [cata, setCata] = useState([]);
  const [smartSerachModalOpen, setSmartSerachModalOpen] = useState(false);
  const [stopInfininitescrol, setStopInfininitescrol] = useState(true);
  const [clearSearchQuery, setClearSearchQuery] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${700}px 0px`
  });
  const [sizeshow, setSizeShow] = useState(false);
  const [finShow, setFinShow] = useState(false);
  const [auth, setAuth] = useState(false);
  const [bhide, setBhide] = useState(false);
  const [sort, setSort] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setFinShow(json.data[0].attributes.setFinish);

      setSizeShow(extractedData);
      // console.log('json.data[0].attributes.Authorised', json.data[0].attributes.Authorised);
      setAuth(json.data[0].attributes.Authorised);
      setBhide(json.data[0].attributes.BulkHide);
      setSort(json.data[0].attributes.SortBy);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedUpdatedDateRange, setSelectedUpdatedDateRange] = useState(null);
  const handleDatechange = value => {
    setCurrentPage(1);
    setData123([]);
    setSelectedDateRange(value);
  };
  const handleUpdatedDatechange = value => {
    setCurrentPage(1);
    setData123([]);
    setSelectedUpdatedDateRange(value);
  };
  const AddedOn = [
    'Today',
    'Yesterday',
    'This week',
    'Last week',
    'This month',
    'Last month',
    'Last 3 month',
    'Last 6 month'
  ].map(item => ({ label: item, value: item }));

  const [limit, setLimit] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [imagesearchedids, setImagesearchedids] = useState([]);
  const formatDateToISO = date => date.toISOString();

  const getFirstDayOfWeek = date => {
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - firstDay.getDay()); // Sunday is the first day of the week
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfMonth = date => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfLastMonth = date => {
    const firstDayOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    firstDayOfLastMonth.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDayOfLastMonth);
  };

  const getLastDayOfLastMonth = date => {
    const lastDayOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
    lastDayOfLastMonth.setHours(23, 59, 59, 999);
    return formatDateToISO(lastDayOfLastMonth);
  };

  const getDateDaysAgo = (date, days) => {
    const result = new Date(date);
    result.setDate(date.getDate() - days);
    result.setHours(0, 0, 0, 0);
    return formatDateToISO(result);
  };
  const [alsort, setAlsort] = useState('A');
  const [sortValue, setSortValue] = useState({ label: 'Newest First', value: 'id:desc' });
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const SORT_OPTIONS = {
    A: { label: 'Newest First', value: 'id:desc' },
    B: { label: 'Oldest First', value: 'id:asc' },
    C: { label: 'Style No (A → Z)', value: 'ProductId:asc' },
    D: { label: 'Style No (Z → A)', value: 'ProductId:desc' },
    E: { label: 'Product Name (A → Z)', value: 'ProductName:asc' },
    F: { label: 'Product Name (Z → A)', value: 'ProductName:desc' }
    // E: { label: "Cost (Low → High)", value: "ProductCost:asc" },
    // F: { label: "Cost (High → Low)", value: "ProductCost:desc" },
    // G: { label: "Authorized (Newest)", value: "AuthDate:desc" },
    // H: { label: "Authorized (Oldest)", value: "AuthDate:asc" }
  };
  const getSortQuery = (sortKey: string) => {
    return SORT_OPTIONS[sortKey]?.value || 'id:desc';
  };
  const fetchData = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    let showsort = getSortQuery(sortValue);

    let imagesearchedidfilter = '';
    if (imagesearchedids.length > 0) {
      const idFilterString = imagesearchedids.map(id => `filters[id][$eq]=${id}`).join('&');
      imagesearchedidfilter = `&${idFilterString}`;
    }
    let categoryFilter = '';
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[CategoryCode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }
    let protypeFilter = '';
    if (selectedProductType.length > 0) {
      const protypeFilterString = selectedProductType
        .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
        .join('&');
      protypeFilter = `&${protypeFilterString}`;
    }
    let colorFilter = '';
    if (selectedColor.length > 0) {
      const colorFilterString = selectedColor
        .map(
          color =>
            `filters[$or][0][ColorCode][$eq]=${color}&filters[$or][1][SetSizes][ColorCode][$eq]=${color}`
        )
        .join('&');
      colorFilter = `&${colorFilterString}`;
    }
    let finishFilter = '';
    if (selectedFinish.length > 0) {
      const finishFilterString = selectedFinish
        .map(finish => `filters[FinishCode][$eq]=${finish}`)
        .join('&');
      finishFilter = `&${finishFilterString}`;
    }
    let hsnFilter = '';
    if (selectedhsn.length > 0) {
      const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
      hsnFilter = `&${hsnFilterString}`;
    }
    let matFilter = '';
    if (selectedmaterial.length > 0) {
      const matFilterString = selectedmaterial
        .map(mat => `filters[ProductionDetail][MaterialCode][$eq]=${mat}`)
        .join('&');
      matFilter = `&${matFilterString}`;
    }
    let buyerFilter = '';
    if (selectedBuyer.length > 0) {
      const buyerFilterString = selectedBuyer
        .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
        .join('&');
      buyerFilter = `&${buyerFilterString}`;
    }
    let searchFilter = '';
    if (selectedSearch.length > 0) {
      const SearchFilterString = selectedSearch
        .map(search => `filters[SearchKeyword][$eq]=${search}`)
        .join('&');
      searchFilter = `&${SearchFilterString}`;
    }
    let aliasFilter = '';
    if (selectedAlias.length > 0) {
      const aliasFilterString = selectedAlias
        .map(alias => `filters[ProductId][$eq]=${alias}`)
        .join('&');
      aliasFilter = `&${aliasFilterString}`;
    }
    let pronFilter = '';
    if (selectedpron.length > 0) {
      const pronFilterString = selectedpron
        .map(pron => `filters[ProductName][$eq]=${pron}`)
        .join('&');
      pronFilter = `&${pronFilterString}`;
    }
    let prodFilter = '';
    if (selectedpd.length > 0) {
      const prodFilterString = selectedpd
        .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
        .join('&');
      prodFilter = `&${prodFilterString}`;
    }
    let madeFilter = '';
    if (selectedmade.length > 0) {
      const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
      madeFilter = `&${madeFilterString}`;
    }
    let skuFilter = '';
    if (selectedsku.length > 0) {
      const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
      skuFilter = `&${skuFilterString}`;
    }
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry = `filters[$or][0][ProductId][$containsi]=${imagesearchedidfilter}${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][SearchKeyword][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
    }

    let datefilter = '';
    let updateddatefilter = '';

    const today = new Date();
    const startOfToday = new Date(today.setHours(0, 0, 0, 0)); // Set time to 00:00:00
    const endOfToday = new Date(); // Current time

    switch (selectedDateRange) {
      case 'Today':
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        datefilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
        break;

      case 'This week':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        datefilter = '';
        break;
    }

    switch (selectedUpdatedDateRange) {
      case 'Today':
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        updateddatefilter = `&filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
        break;

      case 'This week':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        updateddatefilter = '';
        break;
    }
    // let showsort = 'id:desc';
    if (alsort == 'B') {
      showsort = 'id:asc';
    } else if (alsort == 'C') {
      showsort = 'ProductId:asc';
    } else if (alsort == 'D') {
      showsort = 'ProductId:desc';
    } else if (alsort == 'F') {
      showsort = 'ProductCost:asc';
    } else if (alsort == 'D') {
      showsort = 'ProductCost:desc';
    } else if (alsort === 'G') {
      showsort = 'AuthDate:desc'; // Authorized Newest First
    } else if (alsort === 'H') {
      showsort = 'AuthDate:asc'; // Authorized Oldest First
    }
    let showpFilter = `&filters[Authorized][$eq]=Authorised`;
    const response = await fetch(
      `${ipp}/api/products?populate=*&sort[0]=${showsort}&pagination[page]=${currentPage}${imagesearchedidfilter}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}${showpFilter}${searchQryFilter}&${updateddatefilter}&${datefilter}`
    );

    const json = await response.json();
    setLimit(json.data.length);

    if (currentPage === 1) {
      setData123(json.data);
    } else {
      if (json.meta.pagination.total > 25) {
        setData123(prevData => [...prevData, ...json.data]);
        SetIsLoadingTableData(false);
      }
    }
    setMeta123(json.meta);
    dispatch(setProductCount(json.meta.pagination.total));
    setIsLoading(false);
  };

  const TableFetchData = async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    let categoryFilter = '';
    let showsort = getSortQuery(sortValue);
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[CategoryCode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }
    let protypeFilter = '';
    if (selectedProductType.length > 0) {
      const protypeFilterString = selectedProductType
        .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
        .join('&');
      protypeFilter = `&${protypeFilterString}`;
    }
    let colorFilter = '';
    if (selectedColor.length > 0) {
      const colorFilterString = selectedColor
        .map(
          color =>
            `filters[$or][0][ColorCode][$eq]=${color}&filters[$or][1][SetSizes][ColorCode][$eq]=${color}`
        )
        .join('&');
      colorFilter = `&${colorFilterString}`;
    }
    let finishFilter = '';
    if (selectedFinish.length > 0) {
      const finishFilterString = selectedFinish
        .map(finish => `filters[FinishCode][$eq]=${finish}`)
        .join('&');
      finishFilter = `&${finishFilterString}`;
    }
    let hsnFilter = '';
    if (selectedhsn.length > 0) {
      const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
      hsnFilter = `&${hsnFilterString}`;
    }
    let matFilter = '';
    if (selectedmaterial.length > 0) {
      const matFilterString = selectedmaterial
        .map(mat => `filters[ProductionDetail][MaterialCode][$eq]=${mat}`)
        .join('&');
      matFilter = `&${matFilterString}`;
    }
    let buyerFilter = '';
    if (selectedBuyer.length > 0) {
      const buyerFilterString = selectedBuyer
        .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
        .join('&');
      buyerFilter = `&${buyerFilterString}`;
    }
    let searchFilter = '';
    if (selectedSearch.length > 0) {
      const SearchFilterString = selectedSearch
        .map(search => `filters[SearchKeyword][$eq]=${search}`)
        .join('&');
      searchFilter = `&${SearchFilterString}`;
    }
    let aliasFilter = '';
    if (selectedAlias.length > 0) {
      const aliasFilterString = selectedAlias
        .map(alias => `filters[ProductId][$eq]=${alias}`)
        .join('&');
      aliasFilter = `&${aliasFilterString}`;
    }
    let pronFilter = '';
    if (selectedpron.length > 0) {
      const pronFilterString = selectedpron
        .map(pron => `filters[ProductName][$eq]=${pron}`)
        .join('&');
      pronFilter = `&${pronFilterString}`;
    }
    let prodFilter = '';
    if (selectedpd.length > 0) {
      const prodFilterString = selectedpd
        .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
        .join('&');
      prodFilter = `&${prodFilterString}`;
    }
    let madeFilter = '';
    if (selectedmade.length > 0) {
      const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
      madeFilter = `&${madeFilterString}`;
    }
    let skuFilter = '';
    if (selectedsku.length > 0) {
      const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
      skuFilter = `&${skuFilterString}`;
    }
    let authFilter = '';
    if (authst.length > 0) {
      authFilter = `&filters[Authorized][$eq]=${authst}`;
    }
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][SearchKeyword][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
    }
    let datefilter = '';
    let updateddatefilter = '';

    const today = new Date();
    const startOfToday = new Date(today.setHours(0, 0, 0, 0)); // Set time to 00:00:00
    const endOfToday = new Date(); // Current time

    switch (selectedDateRange) {
      case 'Today':
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        datefilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
        break;

      case 'This week':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        datefilter = '';
        break;
    }

    switch (selectedUpdatedDateRange) {
      case 'Today':
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        updateddatefilter = `&filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
        break;

      case 'This week':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        updateddatefilter = '';
        break;
    }
    // let showsort = 'id:desc';
    if (alsort == 'B') {
      showsort = 'id:asc';
    } else if (alsort == 'C') {
      showsort = 'ProductId:asc';
    } else if (alsort == 'D') {
      showsort = 'ProductId:desc';
    } else if (alsort == 'F') {
      showsort = 'ProductCost:asc';
    } else if (alsort == 'D') {
      showsort = 'ProductCost:desc';
    } else if (alsort === 'G') {
      showsort = 'AuthDate:desc'; // Authorized Newest First
    } else if (alsort === 'H') {
      showsort = 'AuthDate:asc'; // Authorized Oldest First
    }
    const response = await fetch(
      `${ipp}/api/products?populate=*&sort[0]=${showsort}&pagination[page]=${page}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}${authFilter}${searchQryFilter}&${updateddatefilter}&${datefilter}`
    );

    const json = await response.json();
    setTableData(json.data);

    setTableMeta(json.meta);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    TableFetchData();
  }, [page, reload]);
  useEffect(() => {
    TableFetchData();
  }, [authst]);

  const [checkedKeys, setCheckedKeys] = useState<number[]>([]);
  const [showtab, setShowtab] = useState(1);
  const [showDrawer, setShowDrawer] = useState(false);
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  const [modeldata, setmodeldata] = useState([]);
  const [multipleImages, setMultipleImages] = useState([]);
  const handleClose = () => setOpen(false);
  let checked = false;
  let indeterminate = false;
  if (checkedKeys.length === data123.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < data123.length) {
    indeterminate = true;
  }

  const handletab = e => {
    setShowtab(e);
    const x = document.getElementById('row');
    const y = document.getElementById('second');
    const dd = document.getElementById('bt');
    const dde = document.getElementById('bte');
    const dpt = document.getElementById('pt');
    const dat = document.getElementById('at');
    const daat = document.getElementById('aat');
    if (x?.click) {
      x.hidden = true;
      if (dd) dd.style.display = 'none';
      if (dde) dde.style.display = 'block';
      dpt.style.display = 'none';
      dat.style.display = 'none';
      daat.style.display = 'none';
    }
    if (x?.click) {
      y.hidden = false;
      if (dd) dd.style.display = 'block';
      if (dde) dde.style.display = 'none';
      dpt.style.display = 'block';
      dat.style.display = 'block';
      daat.style.display = 'block';
    }
  };
  const handletab2 = e => {
    setShowtab(e);
    const x = document.getElementById('row');
    const y = document.getElementById('second');
    const dd = document.getElementById('bt');
    const dde = document.getElementById('bte');
    const dpt = document.getElementById('pt');
    const dat = document.getElementById('at');
    const daat = document.getElementById('aat');
    if (y?.click) {
      y.hidden = true;
      if (dd) dd.style.display = 'block';
      if (dde) dde.style.display = 'none';
      dpt.style.display = 'block';
      dat.style.display = 'block';
      daat.style.display = 'block';
    }
    if (y?.click) {
      x.hidden = false;
      if (dd) dd.style.display = 'none';
      if (dde) dde.style.display = 'block';
      dpt.style.display = 'none';
      dat.style.display = 'none';
      daat.style.display = 'none';
    }
  };

  const [isActive1, setIsActive1] = useState(false);
  const [isActive2, setIsActive2] = useState(true);
  const handleClick1 = () => {
    handletab(2);
    setIsActive1(!isActive1);
    setIsActive2(false);
  };

  const handleClick2 = () => {
    handletab2(1);
    setIsActive1(isActive2);
    setIsActive2(true);
  };
  const tooltip = <Tooltip>List View</Tooltip>;
  const tooltip1 = <Tooltip>Grid View</Tooltip>;
  const ip = ipp;

  const handleEditRow = rowData => {
    setEditedRowIds(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedData(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
  };
  const handleSaveRow = async (rowId: string) => {
    try {
      const rowData = tableData.find(row => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      // Trim `CategoryName` and check for special characters
      const updatedProductId = editedData[rowId]?.ProductId?.trim();
      const updatedProductName = editedData[rowId]?.ProductName?.trim();
      const updatedCategory = editedData[rowId]?.CategoryName;
      const updatedProductType = editedData[rowId]?.ProductTypeName;

      if (!updatedProductId) {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.AliasCode}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      if (!updatedProductName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.ProductName}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      if (!updatedCategory) {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.Category}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      if (!updatedProductType) {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.ProductType}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      const { data: updatealiasData } = await axios.get(
        `${ip}/api/products?filters[ProductId][$eqi]=${updatedProductId}&filters[id][$ne]=${rowId}`
      );
      if (updatealiasData.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.AliasCode} {updatedProductId} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      const updatedRowData: RowData = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedData[rowId] }
      };
      delete updatedRowData.attributes.CoverImage;
      delete updatedRowData.attributes.MultipleImage;
      const response = await fetch(`${ipp}/api/products/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: updatedRowData.attributes })
      });
      if (response.ok) {
        TableFetchData();
        setEditedRowIds(prevRowIds => prevRowIds.filter(id => id !== rowId));
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };
  const toaster = useToaster();
  const handleInputChange = (rowId, fieldName, value) => {
    // If the ProductId is unique, update the state with the new value
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...data123.find(row => row.id === rowId).attributes };
      }
      // Special handling for 'MOQ'
      updatedData[rowId][fieldName] = fieldName === 'MOQ' ? value?.toString().trim() || '0' : value;
      return updatedData;
    });
  };

  const handleInputChange2 = (rowId, fieldName, fieldCode, value, data) => {
    const selectedData = data.find(item => item.label === value);
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...data123.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      updatedData[rowId][fieldCode] = selectedData ? selectedData.value : ''; // Set Code based on selected Name
      return updatedData;
    });
  };

  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  useEffect(() => {
    fetchCategory(setCategorydata, isLoadingc, setIsLoadingc, SetIsLoadingTableData, setProgress);
  }, [selectedAlias]);

  const [colordata, setColordata] = React.useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  useEffect(() => {
    fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor);
  }, []);

  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    if (selectedCategoryCode) {
      fetchProductTypes(setProductypedata, isLoadingpro, setIsLoadingpro, selectedCategoryCode);
    }
  }, [selectedCategoryCode]);

  const [finishdata, setFinishdata] = useState([]);
  const [isLoadingfin, setIsLoadingfin] = useState(false);
  useEffect(() => {
    fetchFinishes(setFinishdata, isLoadingfin, setIsLoadingfin);
  }, []);

  const [materialdata, setMaterialdata] = React.useState([]);
  const [isLoadingmat, setIsLoadingmat] = React.useState(false);
  useEffect(() => {
    fetchMaterials(setMaterialdata, isLoadingmat, setIsLoadingmat);
  }, []);

  const [hsndata, setHsndata] = React.useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = React.useState(false);
  useEffect(() => {
    fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn);
  }, []);

  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  useEffect(() => {
    fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu);
  }, []);

  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  useEffect(() => {
    fetchSearchKeyword(setSearchdata, isLoadingse, setIsLoadingse);
  }, []);

  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  useEffect(() => {
    fetchProductName(setProdNamedata, isLoadingpron, setIsLoadingpron);
  }, []);

  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  useEffect(() => {
    fetchProductDesign(setProdDdata, isLoadingprod, setIsLoadingprod);
  }, []);

  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  useEffect(() => {
    fetchMadeBy(setMadedata, isLoadingmade, setIsLoadingmade);
  }, []);

  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadingalias] = useState(false);
  const [displayedData, setDisplayedData] = useState([]);
  const itemsPerPage = 100;
  const observer = useRef();

  useFilter(
    selectedCategory,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedAlias,
    setAliasdata,
    setFinishdata,
    setColordata,
    setCategorydata,
    setProductypedata
  );

  useEffect(() => {
    fetchAlias(setAliasdata, isLoadingalias, setIsLoadingalias);
  }, []);

  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadinsku] = useState(false);
  useEffect(() => {
    fetchSkuUnique(setSkudata, isLoadingsku, setIsLoadinsku);
  }, []);

  // useEffect for clearing searchQuery
  useEffect(() => {
    if (clearSearchQuery) {
      fetchData();
      TableFetchData();
    }
  }, [clearSearchQuery]);

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    setPage(1);
    fetchData(); // Your data fetching function
    TableFetchData(); // Another data fetching function
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes

  useEffect(() => {
    setCurrentPage(1);
    setPage(1);
    fetchData();
    TableFetchData();
    // fetchPtype();
  }, [
    selectedUpdatedDateRange,
    selectedDateRange,
    imagesearchedids,
    selectedCategory,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedhsn,
    selectedmaterial,
    selectedBuyer,
    selectedSearch,
    selectedAlias,
    selectedpron,
    selectedpd,
    selectedmade,
    selectedsku,
    authst,
    alsort,
    auth
  ]);
  const handleFilterChange = (
    filterType,
    value,
    prevValue,
    clearSearchQuery,
    setClearSearchQuery
  ) => {
    const tempsearchq = searchQuery;
    setSearchQuery(''); // Clear the search query first

    const anyOtherFilterSelected =
      selectedCategory.length > 0 ||
      selectedProductType.length > 0 ||
      selectedColor.length > 0 ||
      selectedFinish.length > 0 ||
      selectedhsn.length > 0 ||
      selectedmaterial.length > 0 ||
      selectedBuyer.length > 0 ||
      selectedSearch.length > 0 ||
      selectedAlias.length > 0 ||
      selectedpron.length > 0 ||
      selectedpd.length > 0 ||
      selectedmade.length > 0 ||
      selectedsku.length > 0;

    // Handle setting clearSearchQuery flag
    if (anyOtherFilterSelected || prevValue.length === 0) {
      setClearSearchQuery(true);
    } else {
      setClearSearchQuery(false);
      setSearchQuery(tempsearchq);
    }

    // Set the filter state for the specific filter type
    switch (filterType) {
      case 'category':
        setSelectedCategory(value);
        break;
      case 'productType':
        setSelectedProductType(value);
        break;
      case 'color':
        setSelectedColor(value);
        break;
      case 'finish':
        setSelectedFinish(value);
        break;
      case 'hsn':
        setSelectedhsn(value);
        break;
      case 'material':
        setSelectedmaterial(value);
        break;
      case 'buyer':
        setSelectedBuyer(value);
        break;
      case 'search':
        setSelectedSearch(value);
        break;
      case 'alias':
        setSelectedAlias(value);
        break;
      case 'productName':
        setSelectedPron(value);
        break;
      case 'productDescription':
        setSelectedProd(value);
        break;
      case 'made':
        setSelectedMade(value);
        break;
      case 'sku':
        setSelectedSku(value);
        break;
      default:
        break;
    }

    // Reset pagination
    setPage(1);
    setCurrentPage(1);

    setReload(prev => !prev);
  };
  const handleCategoryChange = value => {
    handleFilterChange('category', value, selectedCategory, clearSearchQuery, setClearSearchQuery);
  };
  const handleProductTypeChange = value => {
    handleFilterChange(
      'productType',
      value,
      selectedProductType,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleColorChange = value => {
    handleFilterChange('color', value, selectedColor, clearSearchQuery, setClearSearchQuery);
  };
  const handleFinishChange = value => {
    handleFilterChange('finish', value, selectedFinish, clearSearchQuery, setClearSearchQuery);
  };
  const handleHSNChange = value => {
    handleFilterChange('hsn', value, selectedhsn, clearSearchQuery, setClearSearchQuery);
  };
  const handleMaterialChange = value => {
    handleFilterChange('material', value, selectedmaterial, clearSearchQuery, setClearSearchQuery);
  };
  const handleBuyerChange = value => {
    handleFilterChange('buyer', value, selectedBuyer, clearSearchQuery, setClearSearchQuery);
  };
  const handleSearchChange = value => {
    handleFilterChange('search', value, selectedSearch, clearSearchQuery, setClearSearchQuery);
  };
  const handleAliasChange = value => {
    handleFilterChange('alias', value, selectedAlias, clearSearchQuery, setClearSearchQuery);
  };
  const handleProNameChange = value => {
    handleFilterChange('productName', value, selectedpron, clearSearchQuery, setClearSearchQuery);
  };
  const handleProDChange = value => {
    handleFilterChange(
      'productDescription',
      value,
      selectedpd,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleMadeChange = value => {
    handleFilterChange('made', value, selectedmade, clearSearchQuery, setClearSearchQuery);
  };
  const handleSkuChange = value => {
    handleFilterChange('sku', value, selectedsku, clearSearchQuery, setClearSearchQuery);
  };

  const [hoveredImage, setHoveredImage] = useState(null);

  const history = useNavigate();
  const handleEditAllRowCategory = rowData => {
    console.log(rowData);
    history(`/${ugr}/products-create?pId=${rowData.id}&id=${rowData.attributes.Variant_Id}`);
  };
  const pid = (id, varid) => {
    history(`/${ugr}/products-create?pId=${id}&id=${varid}`);
  };
  const fetchPtype = async () => {
    let categoryFilter = '';
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[Categorycode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }

    try {
      const response = await fetch(
        `${ip}/api/mstproducttypes?populate=*&pagination[pageSize]=10000&${categoryFilter}&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      // console.log('RESPONSE PRODUCT TYPE :', json);

      const allData = [];
      const processedData = json.data.map(item => ({
        label: item.attributes.ProductTypeName,
        value: item.attributes.ProductTypeCode
      }));
      allData.push(...processedData);

      setProductypedata(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  useEffect(() => {
    fetchPtype();
  }, selectedCategory);

  const [open1, setOpen1] = React.useState(false);
  const [openPrnt, setOpenPrnt] = React.useState(false);

  const [size1, setSize1] = React.useState();
  const handleOpenPrint = value => {
    if (selectedRowIds.length == 0) {
      toaster.push(
        <Message showIcon type="error">
          Please Select Products.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      setOpenPrnt(true);
    }
  };
  const handleClosePrint = () => setOpenPrnt(false);
  const handleOpen1 = value => {
    setSize1(value);
    setOpen1(true);
  };
  const handleClose1 = () => setOpen1(false);

  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchProductLabel(setLabel);
  }, []);
  const [selectedRowIds, setSelectedRowIds] = React.useState([]);

  useEffect(() => {
    setSelectedRowIds([]);
    fetchDatacatat();
  }, [selectedCategory, isActive1]);

  const [loadingselectedRowIds, setloadingSelectedRowIds] = useState(false);
  const fetchDatacatat = async () => {
    setloadingSelectedRowIds(true);
    try {
      let categoryFilter = '';
      if (selectedCategory.length > 0) {
        const categoryFilterString = selectedCategory
          .map(cat => `filters[CategoryCode][$eq]=${cat}`)
          .join('&');
        categoryFilter = `&${categoryFilterString}`;
      }
      const query = selectedRowIds.map(id => `filters[id][$in]=${id}`).join('&');
      const response = await fetch(
        `${ip}/api/products?populate=*&${query}&filters[Authorized][$eq]=Authorised&filters[Authorized][$eq]=Pending&pagination[page]=1${categoryFilter}`
      );
      const json = await response.json();
      const allData2 = [];
      const pageResponse = await fetch(
        `${ip}/api/products?populate=*&${query}&filters[Authorized][$eq]=Authorised&filters[Authorized][$eq]=Pending&pagination[pageSize]=${json.meta.pagination.total}${categoryFilter}`
      );
      const pageJson = await pageResponse.json();
      allData2.push(...pageJson.data);

      // Set the filtered data to state
      setCata(allData2);
      // setTableData(allData2);
      setIsLoadingbu(false);
      setloadingSelectedRowIds(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
      setIsLoadingbu(false);
      setloadingSelectedRowIds(false);
    }
  };
  const handleSelectAll = (isChecked, data) => {
    console.log('isChecked:', isChecked);
    console.log('data:', data);
    if (isChecked) {
      const allRowIds = data
        .filter(item => item.attributes.Authorized == authst)
        .map(row => row.id);
      setSelectedRowIds(allRowIds);
    } else {
      setSelectedRowIds([]);
    }
    console.log(typeof selectedRowIds.length, typeof tableMeta?.pagination?.total);
    console.log(typeof selectedRowIds.length == typeof tableMeta?.pagination?.total);
    console.log(selectedRowIds.length, tableMeta?.pagination?.total);
  };

  // Function to toggle individual row selection
  const handleSelectRow = rowId => {
    setSelectedRowIds(
      prevSelected =>
        prevSelected.includes(rowId)
          ? prevSelected.filter(id => id !== rowId) // Deselect
          : [...prevSelected, rowId] // Select
    );
  };

  const [showDimm, setShowDimm] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleCloseDimm = () => setShowDimm(false);
  const handleOpenDimm = row => {
    setSelectedRow(row);
    console.log('ROW :', row);
    setShowDimm(true);
  };
  const getDefaultColumns = user => {
    const columns = [
      {
        key: 'select',
        label: 'Select',
        fixed: true,
        width: 60,
        headerCell: (
          <Table.HeaderCell>
            <Checkbox
              inline
              checked={selectedRowIds.length === tableMeta?.pagination?.total} // Check all condition
              indeterminate={
                selectedRowIds.length > 0 && selectedRowIds.length < tableMeta?.pagination?.total
              }
              // indeterminate={selectedRowIds.length > 0 && selectedRowIds.length < cata.length}
              onChange={(value, checked) => handleSelectAll(checked, cata)}
              style={{ marginLeft: '-5px', marginTop: '-5px' }}
            />
          </Table.HeaderCell>
        ),
        cell: (
          <Table.Cell>
            {rowData => (
              <Checkbox
                inline
                checked={selectedRowIds.includes(rowData.id)}
                onChange={() => handleSelectRow(rowData.id)}
                style={{ marginLeft: '-5px' }}
              />
            )}
          </Table.Cell>
        )
      },
      {
        key: 'Image',
        label: 'Image',
        fixed: true,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>Image</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Table.Cell>
            {rowData => {
              // Define a function to show the enlarged image on hover
              const renderTooltip = imageSrc => (
                <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                  <img
                    src={imageSrc}
                    alt="Product Image"
                    style={{ width: 400, height: 400, objectFit: 'contain' }}
                  />
                </Tooltip>
              );

              return (
                <Whisper
                  trigger="hover"
                  placement="right"
                  speaker={renderTooltip(
                    `${ipp}${rowData.attributes?.CoverImage?.data?.attributes?.url}`
                  )}
                >
                  <img
                    src={`${ipp}${rowData.attributes?.CoverImage?.data?.attributes?.url}`}
                    alt="Product Image"
                    style={{ width: 50, height: 50, marginTop: '-16px', objectFit: 'contain' }}
                  />
                </Whisper>
              );
            }}
          </Table.Cell>
        )
      },
      {
        key: 'ProductId',
        label: `${label[0]?.attributes.AliasCode}`,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.AliasCode}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <Input
                  value={editedData[rowData.id]?.ProductId || ''}
                  onChange={value => handleInputChange(rowData.id, 'ProductId', value)}
                />
              ) : (
                rowData.attributes.ProductId
              )
            }
          </Cell>
        )
      },

      {
        key: 'Description',
        label: `${label[0]?.attributes.Description}`,
        width: 300,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.Description}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <Input
                  value={editedData[rowData.id]?.Description || ''}
                  onChange={value => handleInputChange(rowData.id, 'Description', value)}
                />
              ) : (
                rowData.attributes.Description
              )
            }
          </Cell>
        )
      },
      {
        key: 'ProductName',
        label: `${label[0]?.attributes.ProductName}`,
        width: 250,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.ProductName}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <Input
                  value={editedData[rowData.id]?.ProductName || ''}
                  onChange={value => handleInputChange(rowData.id, 'ProductName', value)}
                />
              ) : (
                rowData.attributes.ProductName
              )
            }
          </Cell>
        )
      },

      {
        key: sizeshow ? 'SizeRange' : 'Dimension',
        label: sizeshow ? `${label[0]?.attributes.SizeRange}` : 'Dimension',
        width: 150,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{sizeshow ? label[0]?.attributes.SizeRange : 'Dimension'}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData => {
              const { Length, Width, Height, SizeUnit, SetStatus, SetSizes } = rowData.attributes;
              if (SetStatus === 'Set' && Array.isArray(SetSizes)) {
                return (
                  <Button active onClick={() => handleOpenDimm(rowData.attributes.SetSizes)}>
                    View Size
                  </Button>
                );
              } else {
                return `${Length} x ${Width} x ${Height} ${SizeUnit}`;
              }
            }}
          </Cell>
        )
      },

      {
        key: 'FinishName',
        label: `${label[0]?.attributes.finish}`,
        width: 120,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.finish}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <SelectPicker
                  data={finishdata}
                  labelKey="label"
                  valueKey="label"
                  value={editedData[rowData.id]?.FinishName || ''}
                  onChange={value =>
                    handleInputChange2(rowData.id, 'FinishName', 'FinishCode', value, finishdata)
                  }
                  menuStyle={{
                    maxHeight: 200, // Scrollable dropdown
                    overflowY: 'auto',
                    minWidth: 150, // Minimum menu width
                    width: 250 // Let menu auto-size to content if needed
                  }}
                  searchable
                  placement="bottomEnd"
                />
              ) : (
                rowData.attributes.FinishName
              )
            }
          </Cell>
        )
      },
      {
        key: 'ColorName',
        label: `${label[0]?.attributes.color}`,
        width: 150,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.color}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData => {
              if (rowData.attributes.SetStatus === 'Set') {
                return `---`;
              } else {
                return editedRowIds.includes(rowData.id) ? (
                  <SelectPicker
                    data={colordata}
                    labelKey="label"
                    valueKey="label"
                    value={editedData[rowData.id]?.ColorName || ''}
                    onChange={value =>
                      handleInputChange2(rowData.id, 'ColorName', 'ColorCode', value, colordata)
                    }
                    menuStyle={{
                      maxHeight: 200, // Scrollable dropdown
                      overflowY: 'auto',
                      minWidth: 150, // Minimum menu width
                      width: 250 // Let menu auto-size to content if needed
                    }}
                    searchable
                    placement="bottomEnd"
                  />
                ) : (
                  rowData.attributes.ColorName
                );
              }
            }}
          </Cell>
        )
      },
      {
        key: sizeshow ? 'SizcbmeRange' : null,
        label: sizeshow ? `${label[0]?.attributes.SizeRange}` : 'CBM',
        width: sizeshow ? 0 : 100,
        headerCell: sizeshow ? null : (
          <Table.HeaderCell flexGrow={1}>
            <b>CBM</b>
          </Table.HeaderCell>
        ),
        cell: sizeshow ? null : (
          <Cell>
            {
              rowData =>
                // editedRowIds.includes(rowData.id) ? (
                //   <Input
                //     readOnly
                //     value={editedData[rowData.id]?.cbm || ''}
                //     onChange={value => handleInputChange(rowData.id, 'cbm', value)}
                //   />
                // ) : (
                rowData.attributes.cbm
              // )
            }
          </Cell>
        )
      },
      {
        key: 'ProductCost',
        label: `${label[0]?.attributes.SalePriceINR}`,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.SalePriceINR}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <Input
                  value={editedData[rowData.id]?.ProductCost || ''}
                  onChange={value => handleInputChange(rowData.id, 'ProductCost', value)}
                />
              ) : (
                rowData.attributes.ProductCost
              )
            }
          </Cell>
        )
      },
      {
        key: 'ProductCode',
        label: 'ProductCode',
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>P. Code</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <Input
                  value={editedData[rowData.id]?.ProductCode || ''}
                  onChange={value => handleInputChange(rowData.id, 'ProductCode', value)}
                  readOnly
                />
              ) : (
                rowData.attributes.ProductCode
              )
            }
          </Cell>
        )
      },
      {
        key: 'Category',
        label: `${label[0]?.attributes.Category}`,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.Category}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <SelectPicker
                  data={categorydata}
                  labelKey="label"
                  valueKey="label"
                  value={editedData[rowData.id]?.CategoryName || ''}
                  onChange={value =>
                    handleInputChange2(
                      rowData.id,
                      'CategoryName',
                      'CategoryCode',
                      value,
                      categorydata
                    )
                  }
                  placement="auto"
                />
              ) : (
                rowData.attributes.CategoryName
              )
            }
          </Cell>
        )
      },
      {
        key: 'ProductType',
        label: `${label[0]?.attributes.ProductType}`,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.ProductType}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <SelectPicker
                  data={productypedata}
                  labelKey="label"
                  valueKey="label"
                  value={editedData[rowData.id]?.ProductTypeName || ''}
                  onChange={value =>
                    handleInputChange2(
                      rowData.id,
                      'ProductTypeName',
                      'ProductTypeCode',
                      value,
                      productypedata
                    )
                  }
                  placement="auto"
                />
              ) : (
                rowData.attributes.ProductTypeName
              )
            }
          </Cell>
        )
      },
      {
        key: 'NetWeight',
        label: `${label[0]?.attributes.NetWgt}`,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.NetWgt}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <Input
                  value={editedData[rowData.id]?.NetWeight || ''}
                  onChange={value => handleInputChange(rowData.id, 'NetWeight', value)}
                />
              ) : (
                rowData.attributes.NetWeight
              )
            }
          </Cell>
        )
      },
      {
        key: 'GrossWeight',
        label: `${label[0]?.attributes.GrossWgt}`,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.GrossWgt}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <Input
                  value={editedData[rowData.id]?.GrossWeight || ''}
                  onChange={value => handleInputChange(rowData.id, 'GrossWeight', value)}
                />
              ) : (
                rowData.attributes.GrossWeight
              )
            }
          </Cell>
        )
      },
      {
        key: 'HSNCode',
        label: `${label[0]?.attributes.HSN}`,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.HSN}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <SelectPicker
                  data={hsndata}
                  value={editedData[rowData.id]?.HSNCode || ''}
                  onChange={value => handleInputChange(rowData.id, 'HSNCode', value)}
                  placement="auto"
                />
              ) : (
                rowData.attributes.HSNCode
              )
            }
          </Cell>
        )
      },
      {
        key: 'MOQ',
        label: `${label[0]?.attributes.MOQ}`,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.MOQ}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <InputNumber
                  step={null}
                  value={editedData[rowData.id]?.MOQ || '0'}
                  onChange={value => handleInputChange(rowData.id, 'MOQ', value)}
                />
              ) : rowData.attributes.MOQ === '0' ? (
                '-'
              ) : (
                rowData.attributes.MOQ
              )
            }
          </Cell>
        )
      },
      {
        key: 'BuyerName',
        label: `${label[0]?.attributes.BuyerName}`,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.BuyerName}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <SelectPicker
                  data={buyernamedata}
                  value={editedData[rowData.id]?.BuyerName || ''}
                  onChange={value => handleInputChange(rowData.id, 'BuyerName', value)}
                  placement="auto"
                />
              ) : (
                rowData.attributes.BuyerName
              )
            }
          </Cell>
        )
      },
      {
        key: 'BuyerSku',
        label: `${label[0]?.attributes.BuyerSku}`,
        width: 100,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>{label[0]?.attributes.BuyerSku}</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <Input
                  value={editedData[rowData.id]?.BuyerSku || ''}
                  onChange={value => handleInputChange(rowData.id, 'BuyerSku', value)}
                />
              ) : (
                rowData.attributes.BuyerSku
              )
            }
          </Cell>
        )
      },
      {
        key: 'AuthorisedBy',
        label: 'AuthorisedBy',
        width: 120,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>Authorised By</b>
          </Table.HeaderCell>
        ),
        cell: <Cell>{rowData => rowData.attributes.AuthorisedBy}</Cell>
      },
      {
        key: 'AuthDate',
        label: 'AuthDate',
        width: 180,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>Authorised Date</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData => {
              const authDate = rowData.attributes.AuthDate;
              if (!authDate) {
                return 'N/A'; // Handle cases where AuthDate might be null
              }
              // Format the date and time (e.g., Jan 15, 2025, 10:45 AM)
              const formattedDate = new Date(authDate).toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
              });
              return formattedDate;
            }}
          </Cell>
        )
      },

      {
        key: 'CreatedBy',
        label: 'CreatedBy',
        width: 120,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>Created By</b>
          </Table.HeaderCell>
        ),
        cell: <Cell>{rowData => rowData.attributes.CreatedBy}</Cell>
      },
      {
        key: 'CreatedDate',
        label: 'CreatedDate',
        width: 180,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>Created Date</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Cell>
            {rowData => {
              const createdAt = rowData.attributes.createdAt;
              // Format the date (e.g., YYYY-MM-DD or a more readable format)
              const formattedDate = new Date(createdAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
              });
              return formattedDate;
            }}
          </Cell>
        )
      }
    ];
    if (user?.PRDEdit || user?.Category === 'Admin') {
      columns.push({
        key: 'Action',
        label: 'Action',
        width: 200,
        headerCell: (
          <Table.HeaderCell flexGrow={1}>
            <b>Action</b>
          </Table.HeaderCell>
        ),
        cell: (
          <Table.Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <div>
                  <IconButton
                    size="sm"
                    icon={<CheckIcon />}
                    active
                    onClick={() => handleSaveRow(rowData.id)}
                    style={{ marginRight: '10px' }}
                  />
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={() =>
                      setEditedRowIds(prevRowIds => prevRowIds.filter(id => id !== rowData.id))
                    }
                  />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRow(rowData)}
                  />
                  <Button
                    appearance="subtle"
                    active
                    onClick={() => handleEditAllRowCategory(rowData)}
                    style={{ marginLeft: '10px' }}
                  >
                    Manage
                  </Button>
                </div>
              )
            }
          </Table.Cell>
        )
      });
    }

    return columns;
  };
  const defaultColumns = React.useMemo(
    () => getDefaultColumns(user),
    [user, selectedRowIds, editedRowIds]
  );
  const [columnKeys, setColumnKeys] = React.useState([]);

  useEffect(() => {
    const filteredKeys = defaultColumns
      .map(column => column.key)
      .filter(
        key =>
          ![
            'ProductCost',
            'ProductCode',
            'Category',
            'ProductType',
            'NetWeight',
            'GrossWeight',
            'HSNCode',
            'MOQ',
            'BuyerName',
            'BuyerSku'
          ].includes(key)
      );

    setColumnKeys(filteredKeys);
  }, [defaultColumns]);
  useEffect(() => {
    setColumnKeys(previousKeys => {
      if (sizeshow) {
        return [...previousKeys, 'SizeRange'];
      } else {
        return previousKeys.filter(key => key !== 'SizeRange');
      }
    });
  }, [sizeshow]);
  const [compact, setCompact] = useState(true);
  const [noData, setNoData] = useState(false);
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;

  const FixedLoader = () => (
    <Loader
      content="Loading..."
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '0',
        background: '#fff',
        width: '100%',
        padding: '4px 0'
      }}
    />
  );
  const renderMenu = menu => {
    return (
      <>
        {menu}
        {isLoadingse && <FixedLoader />}
      </>
    );
  };
  const renderMenu1 = menu => {
    return (
      <>
        {menu}
        {isLoadingalias && <FixedLoader />}
      </>
    );
  };
  const renderMenu2 = menu => {
    return (
      <>
        {menu}
        {isLoadingpron && <FixedLoader />}
      </>
    );
  };
  const renderMenu3 = menu => {
    return (
      <>
        {menu}
        {isLoadingprod && <FixedLoader />}
      </>
    );
  };
  const renderMenu4 = menu => {
    return (
      <>
        {menu}
        {isLoadingmade && <FixedLoader />}
      </>
    );
  };
  const renderMenu5 = menu => {
    return (
      <>
        {menu}
        {isLoadingsku && <FixedLoader />}
      </>
    );
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional - adds smooth scroll animation
    });
  };

  const handleChangeLimit = () => {
    setPage(1);
  };
  useEffect(() => {
    if (inView && limit) {
      setCurrentPage(prev => prev + 1);
      SetIsLoadingTableData(true);
    }
  }, [inView]);
  const [dataGrid, setDataGrid] = useState(6);
  const dataaaaa = [
    { label: 'Extra Small', value: 3 },
    { label: 'Small', value: 4 },
    { label: 'Medium', value: 6 },
    { label: 'Large', value: 8 },
    { label: 'Extra Large', value: 12 }
  ];
  const [openMenuBar, setOpenMenuBar] = useState(false);
  const [productUpdate, setProductUpdate] = useState(false);
  const updatachange = () => {
    setProductUpdate(!productUpdate);
  };
  const handleContextMenu = (event, imageUrl) => {
    event.preventDefault();

    if (event.type === 'contextmenu' && event.target.tagName === 'IMG') {
      downloadImage(imageUrl);
    }
  };

  const downloadImage = imageUrl => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(blob => {
        const webpUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = webpUrl;
        link.download = 'image.webp';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(webpUrl);
      }, 'image/webp');
    };
    image.src = imageUrl;
  };

  const [activeKey, setActiveKey] = useState('content1');
  const [isVariant, setIsVariant] = useState(false);

  const handleNavSelect = eventKey => {
    setActiveKey(eventKey);
    if (eventKey == 'content4') {
      setIsVariant(true);
    }
    if (eventKey == 'content5') {
      history(`/${ugr}/space-visualization`);
    }
  };
  const [head, setHead] = useState([]);
  useEffect(() => {
    fetchHeads(setHead);
  }, []);
  ////////////////////--------PRINT FORMAT CODE START------------////////////////////////////
  const [selectedFormat, setSelectedFormat] = useState(null);
  const [maindata, setMainData] = useState([]);
  const [maindataexcel, setMainDataExcel] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAlll, setSelectAlll] = useState(false);
  const [productName, setProductName] = useState(false);
  const [productSellingPrice, setProductSellingPrice] = useState(false);
  const [productBuyerSku, setProductBuyerSku] = useState(false);
  const [productBuyerName, setProductBuyerName] = useState(false);
  const [productHSNCode, setProductHSNCode] = useState(false);
  const [productMOQ, setProductMOQ] = useState(false);
  const [productGrossWeight, setProductGrossWeight] = useState(false);
  const [productNetWeight, setProductNetWeight] = useState(false);
  const [productPTypeName, setProductPTypeName] = useState(false);
  const [productPCode, setProductPCode] = useState(false);
  const [productCategoryName, setProductCategoryName] = useState(false);
  const [productProductId, setProductProductId] = useState(false);
  const [productSize, setProductSize] = useState(false);
  const [productPrice, setProductPrice] = useState(false);
  const [productDescription, setProductDescription] = useState(false);
  const [productSizeUnit, setProductSizeUnit] = useState(false);
  const [productCbm, setProductCbm] = useState(false);
  const [productColorName, setProductColorName] = useState(false);
  const [productFinishName, setProductFinishName] = useState(false);
  const [openAttri, setOpenAttri] = useState(false);
  const [openAttri2, setOpenAttri2] = useState(false);
  const [openAttri4, setOpenAttri4] = useState(false);

  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [catapdf, setCataPdf] = useState([]);
  const [companytype, setCompanytype] = useState('');
  const [inputNumber, setInputNumber] = useState('');
  const [print, setPrint] = useState(false);

  const productLabel: {
    attributes: {
      ProductName: string;
      CategoryName: string;
      ProductCode: string;
      ProductTypeName: string;
      NetWeight: string;
      GrossWeight: string;
      MOQ: string;
      HSNCode: string;
      BuyerName: string;
      BuyerSku: string;
      ColorName: string;
      SellingPrice: string;
      FinishName: string;
      ProductId: string;
      Description: string;
      cbm: string;
      SizeUnit: string;
    };
  }[] = [
    {
      attributes: {
        ProductName: 'Product Name',
        ColorName: 'Color Name',
        FinishName: 'Finish Name',
        ProductId: 'Alias Code',
        Description: 'Description',
        cbm: 'cbm',
        SizeUnit: 'SizeUnit',
        CategoryName: 'Category',
        ProductCode: 'Product Code',
        ProductTypeName: 'Product Type',
        NetWeight: 'Net Weight',
        GrossWeight: 'Gross Weight',
        MOQ: 'MOQ',
        HSNCode: 'HSN Code',
        BuyerName: 'Buyer Name',
        BuyerSku: 'Buyer Sku',
        SellingPrice: 'Sale Price'
      }
    }
  ];

  const options = [
    { label: 'Excel', value: '1' },
    { label: 'PDF 1', value: '2' },
    { label: 'PDF 2', value: '3' },
    { label: 'PDF 3', value: '6' },
    { label: 'QR Code1', value: '4.1' },
    { label: 'QR Code2', value: '4.2' },
    { label: 'QR Code3', value: '5' },
    { label: 'QR Code 3x3', value: '4' },
    { label: 'QR Code 5x5', value: '7' },
    { label: 'QR Code 9x5', value: '8' }
  ];

  const handleDownload = async printOrNot => {
    const setLoading = loadingState => {
      if (printOrNot === 'Print') {
        setIsLoading3(loadingState);
      } else {
        setIsLoading2(loadingState);
      }
    };
    if (selectedRowIds.length === 0) {
      toaster.push(
        <Message showIcon type="error">
          No rows selected for export
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }
    if (inputNumber == '') {
      if (printOrNot === 'Print') {
        setIsLoading3(false);
      } else {
        setIsLoading2(false);
      }
    } else {
      if (printOrNot === 'Print') {
        setIsLoading3(true);
      } else {
        setIsLoading2(true);
      }
    }
    if (selectedFormat === '1') {
      setOpenAttri(true);
    } else if (selectedFormat === '2') {
      await handleDownloadPDF1(
        cata,
        selectedRowIds,
        printOrNot,
        label,
        data2,
        setIsLoading2,
        setIsLoading3
      );
    } else if (selectedFormat === '3') {
      if (printOrNot === 'Print') {
        setPrint(true);
      } else {
        setPrint(false);
      }
      setOpenAttri2(true);
      // await handleDownloadPDF2();
    } else if (selectedFormat === '6') {
      // Set print flag
      setPrint(printOrNot === 'Print');

      // Validate input number
      const number = parseInt(inputNumber, 10);

      if (!number || isNaN(number) || number < 1 || number > 30) {
        toaster.push(
          <Message showIcon type="warning">
            Please enter a valid number between 1 and 30. You entered: {inputNumber}
          </Message>,
          { placement: 'topCenter' }
        );
        setIsLoading3(false);
        setIsLoading2(false);
        return;
      }

      // Validate selected rows
      if (selectedRowIds.length === 0) {
        toaster.push(
          <Message showIcon type="error">
            No rows selected!
          </Message>,
          { placement: 'topCenter' }
        );
        setIsLoading3(false);
        setIsLoading2(false);
        return;
      }

      // Open attributes modal
      setOpenAttri4(true);

      // Everything is valid, you can call your dynamic PDF function here
      // Example: handleDownloadPDF3(attributes, setIsLoading3, setIsLoading2, number, selectedRowIds, cata, label);
    } else if (selectedFormat === '4.1') {
      setLoading(true);
      await handleDownloadQR1(maindata, printOrNot, data1);
      setLoading(false);
    } else if (selectedFormat === '4.2') {
      setLoading(true);
      await handleDownloadQR2(maindata, printOrNot, data1);
      setLoading(false);
    } else if (selectedFormat === '5') {
      setLoading(true);
      await handleDownloadQR3(maindata, printOrNot, data1);
      setLoading(false);
    } else if (selectedFormat === '4') {
      setLoading(true);
      await handleDownloadQR6(maindata, printOrNot, data1);
      setLoading(false);
    } else if (selectedFormat === '7') {
      setLoading(true);
      await handleDownloadQR7(maindata, printOrNot, data1);
      setLoading(false);
    } else if (selectedFormat === '8') {
      setLoading(true);
      await handleDownloadQR8(maindata, printOrNot, data1);
      setLoading(false);
    } else {
      toaster.push(
        <Message showIcon type="error">
          Please Select Format
        </Message>,
        { placement: 'topCenter' }
      );
    }
    if (printOrNot === 'Print') {
      setIsLoading3(false);
    } else {
      setIsLoading2(false);
    }
  };

  //////--------Excel Generate Start-------------//////////
  const handleCustomAttributesOk = async () => {
    setOpenAttri(false); // Close the modal
    // Create an array of selected attributes
    const selectedAttributes = [];
    if (productProductId) selectedAttributes.push('ProductId');
    if (productDescription) selectedAttributes.push('Description');
    if (productName) selectedAttributes.push('ProductName');
    if (productCategoryName) selectedAttributes.push('CategoryName');
    if (productSizeUnit) selectedAttributes.push('SizeUnit');
    if (productFinishName) selectedAttributes.push('FinishName');
    if (productColorName) selectedAttributes.push('ColorName');
    if (productSellingPrice) selectedAttributes.push('SellingPrice');
    if (productBuyerSku) selectedAttributes.push('BuyerSku');
    if (productBuyerName) selectedAttributes.push('BuyerName');
    if (productHSNCode) selectedAttributes.push('HSNCode');
    if (productGrossWeight) selectedAttributes.push('GrossWeight');
    if (productNetWeight) selectedAttributes.push('NetWeight');
    if (productPTypeName) selectedAttributes.push('ProductTypeName');
    if (productPCode) selectedAttributes.push('product Code');
    if (productMOQ) selectedAttributes.push('MOQ');
    if (productCbm) selectedAttributes.push('cbm');

    // Filter data to include only the selected attributes
    const filteredCsvData = csvData
      .map(item => {
        const filteredAttributes = {};
        selectedAttributes.forEach(attr => {
          if (attr === 'SizeUnit') {
            if (item.SetStatus === 'Single') {
              // If Single, show standard size format
              filteredAttributes['SizeUnit'] = `${item.Length || ''} x ${item.Width || ''} x ${
                item.Height || ''
              } ${item.SizeUnit || ''}`.trim();
            } else if (item.SetStatus === 'Set' && item.SetSizes) {
              // If Set, show SetSizes
              filteredAttributes['SizeUnit'] = item.SetSizes.map(
                setItem =>
                  `${setItem.Description} - ${setItem.Length} x ${setItem.Width} x ${setItem.Height} ${setItem.SizeUnit}`
              ).join(',\n');
            } else {
              filteredAttributes['SizeUnit'] = ''; // Default empty if no size data
            }
          } else if (attr === 'FinishName') {
            if (item.SetStatus === 'Single') {
              // If Single, show standard size format
              filteredAttributes['FinishName'] = `${item.FinishName || ''}`.trim();
            } else if (item.SetStatus === 'Set' && item.SetSizes) {
              // If Set, show SetSizes
              filteredAttributes['FinishName'] = item.SetSizes.map(
                setItem => `${setItem.FinishName}`
              ).join(',\n');
            } else {
              filteredAttributes['FinishName'] = ''; // Default empty if no size data
            }
          } else if (attr === 'ColorName') {
            if (item.SetStatus === 'Single') {
              // If Single, show standard size format
              filteredAttributes['ColorName'] = `${item.ColorName || ''}`.trim();
            } else if (item.SetStatus === 'Set' && item.SetSizes) {
              // If Set, show SetSizes
              filteredAttributes['ColorName'] = item.SetSizes.map(
                setItem => `${setItem.ColorName}`
              ).join(',\n');
            } else {
              filteredAttributes['ColorName'] = ''; // Default empty if no size data
            }
          } else if (attr === 'NetWeight') {
            if (item.SetStatus === 'Single') {
              // If Single, show standard size format
              filteredAttributes['NetWeight'] = `${item.NetWt || ''}`.trim();
            } else if (item.SetStatus === 'Set' && item.SetSizes) {
              // If Set, show SetSizes
              filteredAttributes['NetWeight'] = item.SetSizes.map(
                setItem => `${setItem.NetWt}`
              ).join(',\n');
            } else {
              filteredAttributes['NetWeight'] = ''; // Default empty if no size data
            }
          } else {
            filteredAttributes[attr] = item[attr] || '';
          }
        });
        return { id: item.id, Image: item.Image, ...filteredAttributes };
      })
      .sort((a, b) => b.id - a.id);

    await downloadExcelData(filteredCsvData, setIsLoading2, label, selectedRowIds); // Pass filtered data to download function
  };
  const handleCustomAttributesOk2 = async () => {
    setOpenAttri2(false); // Close the modal
    setPrint(false);
    // Create an array of selected attributes
    const selectedAttributes = [];

    if (productDescription) selectedAttributes.push('Description');
    if (productName) selectedAttributes.push('ProductName');
    if (productCategoryName) selectedAttributes.push('CategoryName');
    if (productSizeUnit) selectedAttributes.push('SizeUnit');
    if (productFinishName) selectedAttributes.push('FinishName');
    if (productColorName) selectedAttributes.push('ColorName');
    if (productSellingPrice) selectedAttributes.push('SellingPrice');
    if (productBuyerSku) selectedAttributes.push('BuyerSku');
    if (productBuyerName) selectedAttributes.push('BuyerName');
    if (productProductId) selectedAttributes.push('ProductCost');
    if (productHSNCode) selectedAttributes.push('HSNCode');
    if (productGrossWeight) selectedAttributes.push('GrossWeight');
    if (productNetWeight) selectedAttributes.push('NetWeight');
    if (productPTypeName) selectedAttributes.push('ProductTypeName');
    if (productPCode) selectedAttributes.push('Product Code');
    if (productMOQ) selectedAttributes.push('MOQ');
    if (productCbm) selectedAttributes.push('cbm');
    // Filter data to include only the selected attributes
    const filteredCsvData = csvData.map(item => {
      const filteredAttributes = {};
      selectedAttributes.forEach(attr => {
        filteredAttributes[attr] = item[attr] || '';
      });
      // console.log(object)
      return { id: item.id, Image: item.Image, ...filteredAttributes };
    });

    await handleDownloadPDF2(
      cata,
      selectedRowIds,
      selectedAttributes,
      setIsLoading2,
      setIsLoading3,
      label,
      data2
    );
  };
  const handleCustomAttributesOk3 = async () => {
    setOpenAttri4(false); // Close the modal
    // setPrint(false)
    // Create an array of selected attributes
    const selectedAttributes = [];
    if (productProductId) selectedAttributes.push('ProductId');
    if (productColorName) selectedAttributes.push('ColorName');
    if (productNetWeight) selectedAttributes.push('NetWeight');
    if (productSize) selectedAttributes.push('Size');
    if (productPrice) selectedAttributes.push('SellingPrice');
    if (productPrice) selectedAttributes.push('SellingPriceCurrency');
    // Filter data to include only the selected attributes
    const filteredCsvData = csvData.map(item => {
      const filteredAttributes = {};
      selectedAttributes.forEach(attr => {
        filteredAttributes[attr] = item[attr] || '';
      });
      // console.log(object)
      return { id: item.id, Image: item.Image, ...filteredAttributes };
    });

    await handleDownloadPDF3(
      selectedAttributes,
      setIsLoading3,
      setIsLoading2,
      inputNumber,
      selectedRowIds,
      cata,
      label
    );
  };

  useEffect(() => {
    if (
      productName &&
      productProductId &&
      productDescription &&
      productSizeUnit &&
      productCbm &&
      productSellingPrice &&
      productBuyerSku &&
      productBuyerName &&
      productHSNCode &&
      productMOQ &&
      productGrossWeight &&
      productNetWeight &&
      productPTypeName &&
      productPCode &&
      productCategoryName &&
      productFinishName &&
      productColorName &&
      productCbm
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [
    productName,
    productProductId,
    productDescription,
    productSizeUnit,
    productCbm,
    productFinishName,
    productColorName,
    productSellingPrice,
    productBuyerSku,
    productBuyerName,
    productHSNCode,
    productMOQ,
    productGrossWeight,
    productNetWeight,
    productPTypeName,
    productPCode,
    productCategoryName,
    productCbm
  ]);
  useEffect(() => {
    if (productProductId && productNetWeight && productColorName) {
      setSelectAlll(true);
    } else {
      setSelectAlll(false);
    }
  }, [productProductId, productNetWeight, productColorName]);

  const csvData = cata.map(item => {
    const { id, attributes } = item;
    const {
      MaterialCollection,
      ProductionDetail,
      MultipleImage,
      CoverImage,
      Packaging,
      FortyHQ,
      FortyFT,
      TwentyFT,
      Total_CBM,
      publishedAt,
      updatedAt,
      createdAt,
      BuyerSku,
      BuyerName,
      ProductTypeCode,
      MadeBy,
      ProductDesigner,
      MOQ,
      SearchKeyword,
      ProductCost,
      HSNCode,
      ColorCode,
      FinishCode,
      ProductCode,
      CategoryCode,
      Total_CFT,
      ...restAttributes
    } = attributes;
    const imageUrl = `${ip}${attributes.CoverImage?.data?.attributes?.url || ''}`;
    return {
      id,
      Image: imageUrl,
      ...restAttributes
    };
  });
  useEffect(() => {
    fetchDatacd();
  }, []);
  const fetchDatacd = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData1(json.data);
  };
  //////--------Excel Generate End-------------//////////
  //////--------PDF1 Generate Start-------------//////////

  useEffect(() => {
    fetchcatappt();
  }, []);
  const fetchcatappt = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData2(json.data);
    setCompanytype(json.data[0]?.attributes.Type);
  };

  useEffect(() => {
    if (selectedRowIds.length) {
      fetchDataforQR(); // Fetch more data when currentPage changes
    }
  }, [selectedRowIds]);

  const fetchDataforQR = async () => {
    try {
      // Create a filter to exclude multiple product codes
      const excludeProductCodesFilter = selectedRowIds
        .map(code => `filters[id][$eq]=${code}`)
        .join('&');
      // Fetch data with the filter
      const apiUrl = `${globalIP}/api/products?${excludeProductCodesFilter}&populate=*&pagination[page]=1`;
      const response = await fetch(apiUrl);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/products?${excludeProductCodesFilter}&populate=*&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        allData.push(...pageJson.data);
      }
      const productData = allData.map(item => {
        const materials = item.attributes.ProductionDetail.map(detail =>
          detail.MaterialNm.replace(/\s+/g, ' ').trim()
        )
          .filter((value, index, self) => self.indexOf(value) === index) // Ensure unique materials
          .slice(0, 3); // Limit to a maximum of 3

        // --- FINISHES (New logic based on SetStatus) ---
        let finishList = [];

        if (item.attributes.SetStatus === 'Set' && Array.isArray(item.attributes.SetSizes)) {
          finishList = item.attributes.SetSizes.map(size => size.FinishName?.trim())
            .filter((value, index, self) => value && self.indexOf(value) === index)
            .slice(0, 3);
        } else {
          if (item.attributes.FinishName?.trim()) {
            finishList = [item.attributes.FinishName.trim()];
          }
        }

        return {
          id: item.id,
          code: item.attributes.ProductId,
          name: item.attributes.ProductName,
          size: `${item.attributes.Length}x${item.attributes.Width}x${item.attributes.Height} ${item.attributes.SizeUnit}`,
          pcode: item.attributes.ProductCode,
          image: item?.attributes?.CoverImage?.data?.attributes?.url,
          grwt: item.attributes.GrossWeight,
          ntwt: item.attributes.NetWeight,
          material: materials.join('/'), // Join the unique materials into a string
          finish: finishList.join(' / ')
        };
      });

      setMainData(
        productData.sort((a, b) => {
          // Sort by id in ascending order
          return b.id - a.id; // Change to b.id - a.id for descending order
        })
      );
      setMainDataExcel(allData);
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  };

  const [tableHeight, setTableHeight] = useState(20); // Default height

  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 290;
      const footerHeight = 5;
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };

    calculateHeight();
    window.addEventListener('resize', calculateHeight);

    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  const [isLoadingupdate, setIsLoadingupdate] = useState(false);
  const authstatusChange = async () => {
    try {
      if (selectedRowIds.length === 0) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Products
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        setIsLoadingupdate(true);
        const userName = localStorage.getItem('fullName');
        const cleanName = userName.replace(/\"/g, '');
        for (const ProductId of selectedRowIds) {
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              Authorized: 'Authorised',
              AuthorisedBy: cleanName,
              AuthDate: new Date().toISOString()
            })
          );
          const response = await fetch(`${ip}/api/products/${ProductId}`, {
            method: 'PUT',
            body: formData
          });
          if (response.ok) {
            console.log(`Products with ID ${ProductId} Update successfully.`);
          } else {
            console.error(`Failed to Update fair product with ID ${ProductId}.`);
          }
        }
        setIsLoadingupdate(false);
        setSelectedRowIds([]);
        TableFetchData();
        fetchData();
        setAuthst('Pending');
        toaster.push(
          <Message showIcon type="success">
            {selectedRowIds.length} Products Saved Changes
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } catch (error) {
      console.error('Error Updateing fair products:', error);
    }
  };
  const [sortAlias, setSortAlias] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState('');
  const [data11, setData11] = useState(null);
  const [selectedImagePath, setSelectedImagePath] = useState({ url: '', id: null, default: true });
  const { attributesName } = useLabel();
  const [costid, setCostid] = useState(null);
  const unitOptions = [
    { label: 'Inch', value: 'inch' },
    { label: 'CM', value: 'cm' }
  ];
  const [selectedImageIndex, setSelectedImageIndex] = useState({});
  const getAllImages = item => {
    const cover = item?.attributes?.CoverImage?.data?.attributes?.url || '';

    const uniqueSortedMultipleImages = [...(item?.attributes?.MultipleImage?.data || [])]
      .filter(img => img?.attributes?.url?.trim())
      .filter(
        (img, index, self) => index === self.findIndex(i => i.attributes.url === img.attributes.url)
      )
      .sort((a, b) =>
        a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase())
      )
      .map(img => img.attributes.url);

    return [cover, ...uniqueSortedMultipleImages];
  };
  const handleNextImage = item => {
    const images = getAllImages(item);
    const currentIndex = selectedImageIndex[item.id] || 0;
    const nextIndex = (currentIndex + 1) % images.length;

    setSelectedImageIndex(prev => ({
      ...prev,
      [item.id]: nextIndex
    }));

    setSelectedImagePath({
      url: images[nextIndex],
      id: item.id,
      default: nextIndex === 0
    });
  };

  const handlePrevImage = item => {
    const images = getAllImages(item);
    const currentIndex = selectedImageIndex[item.id] || 0;
    const prevIndex = (currentIndex - 1 + images.length) % images.length;

    setSelectedImageIndex(prev => ({
      ...prev,
      [item.id]: prevIndex
    }));

    setSelectedImagePath({
      url: images[prevIndex],
      id: item.id,
      default: prevIndex === 0
    });
  };
  useEffect(() => {
    const item = modeldata[0]; // Assuming you want the first item in the array

    if (!item) {
      console.error('Item is undefined');
      return;
    }

    if (selectedImageIndex === 0) {
      console.log('imgindex : ' + selectedImageIndex);
      // When selected index is 0, set the CoverImage
      const coverImageUrl = item?.attributes?.CoverImage?.data?.attributes?.url;
      if (coverImageUrl) {
        setSelectedImagePath({
          url: coverImageUrl,
          id: item.id,
          default: true
        });
      } else {
        console.error('Cover image not found');
      }
    } else {
      console.log('imgindex11 : ' + selectedImageIndex);
      // Otherwise, set the corresponding MultipleImage
      const imageIndex = selectedImageIndex - 1; // Subtract 1 because CoverImage is index 0
      const selectedImage = item?.attributes?.MultipleImage?.data?.[imageIndex];
      if (selectedImage && selectedImage?.attributes?.url) {
        setSelectedImagePath({
          url: selectedImage?.attributes?.url,
          id: item.id,
          default: true
        });
      } else {
        console.error('Multiple image not found at index', imageIndex);
      }
    }
  }, [selectedImageIndex, modeldata]);
  const handleSizeChange = value => {
    setSelectedUnit(value);
    const convertedData = convertDimensions(data11, value);
    setData11(convertedData);
  };
  const convertDimensions = (data, selectedUnit) => {
    const conversionFactor = selectedUnit === 'inch' ? 0.393701 : 2.54;

    return data.map(item => {
      // Skip conversion if the SizeUnit matches the selectedUnit
      if (item.SizeUnit === selectedUnit) {
        console.log('Unchanged data:', item);
        return item;
      }

      // Convert dimensions if SizeUnit does not match the selectedUnit
      let convertedItem = {
        ...item,
        Length: (item.Length || 0) * conversionFactor,
        Width: (item.Width || 0) * conversionFactor,
        Height: (item.Height || 0) * conversionFactor,
        SizeUnit: selectedUnit
      };

      console.log('Converted data:', convertedItem);
      return convertedItem;
    });
  };
  const handleOpen = (value, prdcd) => {
    setSize(value);
    setOpen(true);
    setCostid(prdcd);
    const newArray = [...data123];
    const filteredData = newArray.filter(item => item.id === prdcd);
    // setSelectedUnit(filteredData[0].attributes.SizeUnit)
    console.log('filteredData', filteredData);
    if (filteredData[0].attributes.SetStatus === 'Set') {
      setSelectedUnit(filteredData[0].attributes.SetSizes[0].SizeUnit);
      setData11(filteredData[0].attributes.SetSizes);
    } else {
      const data = [
        {
          Length: filteredData[0].attributes.Length,
          Width: filteredData[0].attributes.Width,
          Height: filteredData[0].attributes.Height,
          SizeUnit: filteredData[0].attributes.SizeUnit
        }
      ];
      setSelectedUnit(filteredData[0].attributes.SizeUnit);

      setData11(data);
    }
    setmodeldata(filteredData);
  };
  const items = [
    { key: 'content1', label: 'All Products' },
    { key: 'content2', label: label[0]?.attributes?.Collection },
    { key: 'content3', label: 'Image Edit' },
    { key: 'content4', label: 'Variant Products' },
    { key: 'content5', label: 'Space Visualization' }
  ];
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      {activeKey === 'content1' && (
        <>
          <div
            style={{
              justifyContent: 'space-between',
              width: '-webkit-fill-available',
              position: 'fixed',
              height: '130px',
              background: '#fff',
              zIndex: 1
            }}
          >
            <Stack
              className="table-toolbar product-head"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Stack direction="column" alignItems="flex-start">
                <Stack direction="column" alignItems="flex-start" className="product-det">
                  <Stack direction="row" alignItems="flex-start" spacing={157}>
                    {/* <NavD activeKey={activeKey} handleNavSelect={handleNavSelect} label={label} /> */}
                    <div onClick={() => setOpenMenuBar(!openMenuBar)}>
                      <MenuIcon className="burgerMenu1" />
                    </div>
                  </Stack>
                  <Breadcrumb>
                    <Breadcrumb.Item>
                      <Link to={`/${ugr}/dashboard`}>Home</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Product</Breadcrumb.Item>
                  </Breadcrumb>
                </Stack>
                <Stack wrap spacing={5} className={openMenuBar ? 'product-item' : 'mange-search'}>
                  <HeaderFilter
                    {...{
                      head,
                      label,
                      //data states
                      categorydata,
                      productypedata,
                      colordata,
                      proNamedata,
                      skudata,
                      buyernamedata,
                      finishdata,
                      aliasdata,
                      searchdata,
                      proDdata,
                      madedata,
                      hsndata,
                      materialdata,
                      setCategorydata,
                      setIsLoadingc,
                      isLoadingc,
                      SetIsLoadingTableData,
                      setProgress,
                      setColordata,
                      isLoadingcolor,
                      setIsLoadingcolor,
                      setFinishdata,
                      isLoadingfin,
                      setIsLoadingfin,
                      setHsndata,
                      isLoadinghsn,
                      setIsLoadinghsn,
                      //selectedstates
                      selectedCategory,
                      selectedProductType,
                      selectedColor,
                      selectedpron,
                      selectedsku,
                      selectedBuyer,
                      selectedFinish,
                      selectedAlias,
                      selectedSearch,
                      selectedpd,
                      selectedmade,
                      selectedhsn,
                      selectedmaterial,
                      selectedDateRange,
                      selectedUpdatedDateRange,
                      //onchangehandlers
                      handleCategoryChange,
                      handleProductTypeChange,
                      handleColorChange,
                      handleProNameChange,
                      handleSkuChange,
                      handleBuyerChange,
                      handleFinishChange,
                      handleAliasChange,
                      handleSearchChange,
                      handleProDChange,
                      handleMadeChange,
                      handleHSNChange,
                      handleMaterialChange,
                      handleDatechange,
                      handleUpdatedDatechange,
                      //onopenfunctions
                      fetchCategory,
                      fetchColors,
                      fetchFinishes,
                      fetchProductTypes,
                      fetchAlias,
                      //rendermenus
                      renderMenu2,
                      renderMenu5,
                      renderMenu1,
                      renderMenu,
                      renderMenu3,
                      renderMenu4
                    }}
                  />
                  {/* <AddedOnFIlter
                    {...{
                      showboth: 'both',
                      AddedOn,
                      selectedDateRange,
                      handleDatechange,
                      selectedUpdatedDateRange,
                      handleUpdatedDatechange
                    }}
                  /> */}
                  <AntdBtn
                    icon={<FilterOutlined />}
                    onClick={() => setIsFilterOpen(true)}
                    className="filter-btn"
                    style={{ height: '36px', width: '36px' }}
                  />
                  <Modal
                    title="Filter & Sort"
                    open={isFilterOpen}
                    onCancel={() => setIsFilterOpen(false)} // just close modal on cancel
                    onOk={() => {
                      setCurrentPage(1);
                      setData123([]);
                      setIsFilterOpen(false); // apply effects and close modal
                      TableFetchData();
                      fetchData();
                    }}
                    okText="Apply"
                  >
                    <div style={{ marginBottom: 16 }}>
                      {/* <label style={{ display: "block", marginBottom: 8 }}>
                        Sort By
                      </label> */}

                      <Select
                        value={sortValue} // directly use sortValue
                        onChange={value => setSortValue(value)} // no temp state
                        style={{ width: '100%' }}
                      >
                        {Object.entries(SORT_OPTIONS).map(([key, opt]) => (
                          <Select.Option key={key} value={key}>
                            {opt.label}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Modal>

                  {/* <Select
                    value={sortValue}
                    onChange={(value) => {
                      setSortValue(value);
                      setCurrentPage(1);
                      setData123([]);
                    }}
                    className="sort-select"
                  >
                    {Object.entries(SORT_OPTIONS).map(([key, opt]) => (
                      <Select.Option key={key} value={key}>
                        {opt.label}
                      </Select.Option>
                    ))}
                  </Select> */}
                  <Button appearance="default" active onClick={() => setShowDrawer(true)}>
                    More Filter
                  </Button>
                  <div style={{ display: 'none' }} id="at">
                    {auth === true && (
                      <SelectPicker
                        style={{ width: 120 }}
                        data={authstatus}
                        value={authst}
                        onChange={value => {
                          setAuthst(value);
                          setSelectedRowIds([]);
                        }}
                        searchable={false}
                        cleanable={false}
                      />
                    )}
                  </div>
                  <div>
                    {(selectedCategory.length > 0 ||
                      selectedProductType.length > 0 ||
                      selectedColor.length > 0 ||
                      selectedFinish.length > 0 ||
                      selectedhsn.length > 0 ||
                      selectedmaterial.length > 0 ||
                      selectedBuyer.length > 0 ||
                      selectedSearch.length > 0 ||
                      selectedAlias.length > 0 ||
                      selectedpron.length > 0 ||
                      selectedpd.length > 0 ||
                      selectedmade.length > 0 ||
                      selectedsku.length > 0) && (
                      <b style={{ marginLeft: '6px' }}>
                        Total Products: {data123.length}/{meta123.pagination.total}
                      </b>
                    )}
                    {selectedCategory.length === 0 &&
                      selectedProductType.length === 0 &&
                      selectedColor.length === 0 &&
                      selectedFinish.length === 0 &&
                      selectedhsn.length === 0 &&
                      selectedmaterial.length === 0 &&
                      selectedBuyer.length === 0 &&
                      selectedSearch.length === 0 &&
                      selectedAlias.length === 0 &&
                      selectedpron.length === 0 &&
                      selectedpd.length === 0 &&
                      selectedmade.length === 0 &&
                      selectedsku.length === 0 &&
                      meta123 && (
                        <b>
                          Products: {data123.length}/{meta123?.pagination?.total ?? 0}
                        </b>
                      )}
                  </div>
                </Stack>
              </Stack>
              <Stack
                direction="column"
                alignItems="flex-end"
                spacing={5}
                className="mange-search market-search1 prduct-search2"
              >
                <Stack spacing={5} className="data-grid2 data-customize">
                  <Stack spacing={5}>
                    {(user.PRDEdit === true || user.Category === 'Admin') && (
                      <IconButton
                        onClick={updatachange}
                        icon={productUpdate ? <CloseIcon /> : <EditIcon />}
                        active
                        id="bte"
                        style={{ display: 'block' }}
                      />
                    )}
                    {(user.PRDAdd === true || user.Category === 'Admin') && (
                      <Dropdown title="Add Products" active placement="bottomEnd">
                        <Link className="link" to={`/${ugr}/products-create`}>
                          <Dropdown.Item icon={<AddOutlineIcon />}>Single Upload</Dropdown.Item>
                        </Link>
                        <Link className="link" to={`/${ugr}/bulkproduct`}>
                          <Dropdown.Item icon={<PushMessageIcon />}>Bulk Upload</Dropdown.Item>
                        </Link>
                      </Dropdown>
                    )}
                    {(user.PRDManage === true || user.Category === 'Admin') && (
                      <Link to={`/${ugr}/manageProduct`}>
                        <Button appearance="primary" color="cyan">
                          Manage Product
                        </Button>
                      </Link>
                    )}
                    {/* <Dropdown
                      title="Action"
                      appearance="primary"
                      color="cyan"
                      placement="bottomEnd"
                    >
                      <Link className="link" to={`/${ugr}/product-Selection-Page`}>
                        <Dropdown.Item icon={<AddOutlineIcon />}> Single Costing</Dropdown.Item>
                      </Link>
                      {bhide && (
                        <Link className="link" to={`/${ugr}/bulk-costing`}>
                          <Dropdown.Item icon={<PushMessageIcon />}> Bulk Costing</Dropdown.Item>
                        </Link>
                      )}
                      {(user.PRDManage === true || user.Category === 'Admin') && (
                        <Link to={`/${ugr}/manageProduct`}>
                          <Dropdown.Item icon={<EditFilled />}>
                            Manage Product
                          </Dropdown.Item>
                        </Link>
                      )}
                    </Dropdown> */}
                  </Stack>
                  {(user.CATCustomizeTab === true || user.Category === 'Admin') && (
                    <Stack>
                      <Button
                        appearance="ghost"
                        color="cyan"
                        onClick={() => handleOpen1('sm')}
                        className="product-dtl-btn"
                        id="bt"
                        style={{ display: 'none' }}
                      >
                        Customize
                      </Button>
                    </Stack>
                  )}
                </Stack>

                <Stack spacing={3} className="data-grid1" style={{ marginBottom: '-15px' }}>
                  <AntdDropDown
                    menu={{
                      items,
                      onClick: ({ key }) => handleNavSelect(key)
                    }}
                    trigger={['click']}
                  >
                    <Button>
                      View <EyeFilled />
                    </Button>
                  </AntdDropDown>
                  {sort && (
                    <IconButton icon={<FunnelIcon />} active onClick={() => setSortAlias(true)} />
                  )}
                  <div id="aat" style={{ display: 'none' }}>
                    {authst == 'Pending' && (
                      <Button
                        active
                        color="cyan"
                        onClick={authstatusChange}
                        loading={isLoadingupdate}
                      >
                        Authorise
                      </Button>
                    )}
                  </div>
                  <Button
                    active
                    color="cyan"
                    onClick={handleOpenPrint}
                    id="pt"
                    style={{ display: 'none' }}
                  >
                    Print
                  </Button>

                  <InputGroup inside>
                    <Input
                      placeholder="Search"
                      type="text"
                      value={searchQuery}
                      onChange={value => {
                        setSearchQuery(value);
                      }}
                      className="pdt-srch"
                      style={{ width: '150px' }}
                    />
                    <InputGroup.Addon>
                      <SearchIcon style={{ cursor: 'pointer' }} />
                    </InputGroup.Addon>
                  </InputGroup>

                  <Stack>
                    <ButtonToolbar className="data-grid">
                      {isActive2 && (
                        <SelectPicker
                          data={dataaaaa}
                          searchable={false}
                          style={{ width: 100 }}
                          menuStyle={{ maxWidth: 250, zIndex: 999999 }}
                          container={() => document.body}
                          placeholder="Grid"
                          onChange={e => setDataGrid(!e ? 6 : e)}
                        />
                      )}

                      <ButtonGroup size="md">
                        {/* {imagesearchedids.length > 0 ? (
                          <Whisper
                            placement="bottomEnd"
                            controlId="control-id-hover"
                            trigger="hover"
                            speaker={<Tooltip>Clear Search</Tooltip>}
                          >
                            <IconButton
                              icon={<CloseIcon />}
                              className={'btn btn-outline-secondary'}
                              id="ba"
                              onClick={() => {
                                setCurrentPage(1);
                                setImagesearchedids([]);
                              }}
                            />
                          </Whisper>
                        ) : (
                          <Whisper
                            placement="bottomEnd"
                            controlId="control-id-hover"
                            trigger="hover"
                            speaker={<Tooltip>Smart Search</Tooltip>}
                          >
                            <IconButton
                              icon={<ImageIcon />}
                              className={'btn btn-outline-secondary'}
                              id="ba"
                              onClick={() => {
                                setSmartSerachModalOpen(true);
                                setStopInfininitescrol(false);
                              }}
                            />
                          </Whisper>
                        )} */}
                        <Whisper
                          placement="bottomEnd"
                          controlId="control-id-hover"
                          trigger="hover"
                          speaker={tooltip}
                          className="data-grid"
                        >
                          <IconButton
                            icon={<MenuIcon />}
                            active={isActive1}
                            className={
                              showtab === 2
                                ? 'btn btn-outline-secondary'
                                : 'btn btn-outline-secondary'
                            }
                            onClick={handleClick1}
                            id="ba"
                          />
                        </Whisper>
                        <Whisper
                          placement="bottomEnd"
                          controlId="control-id-hover"
                          trigger="hover"
                          speaker={tooltip1}
                        >
                          <IconButton
                            icon={<GridIcon />}
                            active={isActive2}
                            className={
                              showtab === 1
                                ? 'btn btn-outline-secondary '
                                : 'btn btn-outline-secondary '
                            }
                            onClick={handleClick2}
                            id="bb"
                          />
                        </Whisper>
                      </ButtonGroup>
                    </ButtonToolbar>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>

            <Divider className="divide product-dvd" style={{ marginTop: '29px' }} />
          </div>
          <div className={showtab === 1 ? 'row' : ''} id="row" style={{ marginTop: '110px' }}>
            <Panel className="product-details-pnl">
              <FlexboxGrid
                justify="start"
                style={{ textAlign: 'center', marginTop: '20px' }}
                className="datatbl-img"
              >
                {data123.map(item => (
                  <ProductCard
                    {...{
                      item,
                      label,
                      dataGrid,
                      handleOpen,
                      productUpdate,
                      pid: () => {
                        const url = `/${ugr}/products-create?pId=${item.id}&id=${item.attributes.ProductCode}`;
                        window.open(url, '_blank'); // new tab
                      },
                      showCheckbox: 0, // null means no preference, 0 for editicon ,1 for checkbox
                      showEditIcon: 1, // null means no preference, 0 for editicon ,1 for checkbox
                      showVariant: 0, // null means no preference, 0 for variant label ,1 for variant modal button
                      showQuickView: user.PRDView === true || user.Category === 'Admin' ? 1 : 3 // null means no preference, 0 = only product details ,1= quickview and product deatails
                    }}
                  />
                ))}
              </FlexboxGrid>
            </Panel>
            <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
            {isLoading && <Loader center size="md" speed="fast" content="loading..." />}
            <Stack justifyContent="flex-end">
              <IconButton
                size="sm"
                icon={<SortUpIcon />}
                active
                onClick={scrollToTop}
                style={{
                  position: 'fixed',
                  top: '90%',
                  right: 10,
                  transform: 'translateY(-50%)',
                  zIndex: 0
                }}
              />
            </Stack>
          </div>
          <div
            className={showtab === 2 ? 'tableform' : ''}
            id="second"
            hidden
            style={{ marginTop: '100px' }}
          >
            <ProdductListView
              {...{
                selectedRowIds,
                isLoading,
                noData,
                tableData,
                tableHeight,
                defaultColumns,
                auth,
                isLoading3,
                isLoading2,
                handleDownload,
                columnKeys,
                CustomHeaderCell,
                CustomCell,
                tableMeta,
                page,
                setPage,
                handleChangeLimit,
                openPrnt,
                handleClosePrint,
                options,
                selectedFormat,
                setSelectedFormat,
                setInputNumber,
                setSelectAll,
                setProductName,
                setProductProductId,
                setProductDescription,
                setProductSizeUnit,
                setProductCbm,
                setProductFinishName,
                setProductColorName,
                setProductSellingPrice,
                setProductBuyerSku,
                setProductBuyerName,
                setProductHSNCode,
                setProductMOQ,
                setProductGrossWeight,
                setProductNetWeight,
                setProductPTypeName,
                setProductPCode,
                setProductCategoryName,
                productName,
                openAttri,
                setOpenAttri,
                selectAll,
                label,
                productProductId,
                productDescription,
                productSizeUnit,
                productCbm,
                productFinishName,
                productColorName,
                productSellingPrice,
                productBuyerSku,
                productBuyerName,
                productHSNCode,
                productMOQ,
                productGrossWeight,
                productNetWeight,
                productPTypeName,
                productCategoryName,
                handleCustomAttributesOk,
                openAttri2,
                setOpenAttri2,
                handleCustomAttributesOk2,
                openAttri4,
                setOpenAttri4,
                selectAlll,
                setSelectAlll,
                setProductSize,
                productSize,
                handleCustomAttributesOk3,
                open1,
                handleClose1,
                setColumnKeys,
                setProductPrice,
                productPrice,
                editedRowIds,
              }}
            />
          </div>
        </>
      )}
      {activeKey === 'content2' && (
        <>
          <Library activeKey={activeKey} handleNavSelect={handleNavSelect} label={label} />
        </>
      )}
      {activeKey === 'content3' && (
        <>
          <ProductImage activeKey={activeKey} handleNavSelect={handleNavSelect} label={label} />
        </>
      )}
      {activeKey === 'content4' && (
        <>
          <VariantDatatable
            activeKey={activeKey}
            handleNavSelect={handleNavSelect}
            label={label}
            isVariant={isVariant}
          />
        </>
      )}
      <ProductQuickView
        {...{
          data11,
          label,
          handleClose,
          open,
          size,
          modeldata,
          handlePrevImage,
          handleNextImage,
          selectedImagePath,
          setSelectedImagePath,
          sizeshow,
          unitOptions,
          selectedUnit,
          handleSizeChange,
          convertDimensions,
          finShow,
          attributesName,
          costid
        }}
      />

      {selectedRow && (
        <ShowDimensionModal {...{ showDimm, handleCloseDimm, selectedRow, finShow, label }} />
      )}
      <FilterDrawer
        {...{
          showDrawer,
          setShowDrawer,
          head,
          label,
          //data states
          categorydata,
          productypedata,
          colordata,
          proNamedata,
          skudata,
          buyernamedata,
          finishdata,
          aliasdata,
          searchdata,
          proDdata,
          madedata,
          hsndata,
          materialdata,
          setCategorydata,
          setIsLoadingc,
          isLoadingc,
          SetIsLoadingTableData,
          setProgress,
          setColordata,
          isLoadingcolor,
          setIsLoadingcolor,
          setFinishdata,
          isLoadingfin,
          setIsLoadingfin,
          setHsndata,
          isLoadinghsn,
          setIsLoadinghsn,
          setMaterialdata,
          isLoadingmat,
          setIsLoadingmat,
          //selectedstates
          selectedCategory,
          selectedProductType,
          selectedColor,
          selectedpron,
          selectedsku,
          selectedBuyer,
          selectedFinish,
          selectedAlias,
          selectedSearch,
          selectedpd,
          selectedmade,
          selectedhsn,
          selectedmaterial,
          selectedDateRange,
          selectedUpdatedDateRange,

          //onchangehandlers
          handleCategoryChange,
          handleProductTypeChange,
          handleColorChange,
          handleProNameChange,
          handleSkuChange,
          handleBuyerChange,
          handleFinishChange,
          handleAliasChange,
          handleSearchChange,
          handleProDChange,
          handleMadeChange,
          handleHSNChange,
          handleMaterialChange,
          handleDatechange,
          handleUpdatedDatechange,

          //onopenfunctions
          fetchCategory,
          fetchColors,
          fetchFinishes,
          fetchProductTypes,
          fetchAlias,
          fetchHsn,
          fetchMaterials,
          //rendermenus
          renderMenu2,
          renderMenu5,
          renderMenu1,
          renderMenu,
          renderMenu3,
          renderMenu4
        }}
      />

      {smartSerachModalOpen && (
        <SmartSearchModal
          open={smartSerachModalOpen}
          close={() => setSmartSerachModalOpen(false)}
          setData123={setData123}
          setStopInfininitescrol={setStopInfininitescrol}
          setTableData={setTableData}
          setCurrentPage={setCurrentPage}
          setImagesearchedids={setImagesearchedids}
        />
      )}
      {sortAlias && (
        <SortDrawer
          sortAlias={sortAlias}
          setSortAlias={setSortAlias}
          alsort={alsort}
          setAlsort={setAlsort}
        />
      )}
      <Footer />
    </>
  );
};
export default DataTable;
